import React from 'react';
import './PrivacyPolicy.css'; // optional: if you want to style it
import btn from '../../assets/images/button.svg';

const PrivacyPolicy = ({ setShowPrivacyPolicy }) => {
  const handleClose = (e) => {
    e.stopPropagation();
    setShowPrivacyPolicy(false);
  };

  const handleContainerClick = (e) => {
    if (e.target === e.currentTarget) {
      e.stopPropagation();
      setShowPrivacyPolicy(false);
    }
  };

  return (
    <div className="pp-modal-container" onClick={handleContainerClick}>
      <div className="privacy-policy-modal">
        <div className="modal-dialog modal-lg">
          <div className="p-0">
            <div className="modal-headerpp d-flex justify-content-md-start justify-content-center">
              <h1 className="modal-title fs-5">Privacy and Security</h1>
              <button
                type="button"
                aria-label="Close"
                className="btn-close position-absolute end-0 me-4"
                onClick={handleClose}
              >
                <img src={btn} alt="close" />
              </button>
            </div>
            <div className="modal-bodyp">
              <div className="p-3">
                <h6>
                  Thank you for using JioDAM! Your privacy is important to us.
                  To better protect your privacy, and to help ensure a rewarding
                  experience for all users, we provide this privacy policy.
                </h6>

                <div className="section">
                  <h6>1. SCOPE</h6>
                  <div className="text-content">
                    <p>
                      JioDAM (hereinafter referred to as "Portal", "we", "our",
                      "us") is committed to protecting and respecting your
                      privacy.
                    </p>
                    <p>
                      <span>1.1</span>
                      <span>
                        This policy (this "Privacy Policy"), together with the
                        Terms and Conditions of the Portal outlines the Portal's
                        privacy practices regarding the collection, use and
                        safeguard of your information through the Portal and the
                        services offered thereupon.
                      </span>
                    </p>
                    <p>
                      <span>1.2</span>
                      <span>
                        By using the Portal or registering or signing up for the
                        Portal and submission of personal information; or if you
                        are a minor, the submission of your personal information
                        either by your parents (or your guardian) or by you with
                        the permission of your parents (or guardian) to the
                        Portal will be deemed as your acceptance of this Privacy
                        Policy.
                      </span>
                    </p>
                    <p>
                      <span>1.3</span>
                      <span>
                        The Terms are an electronic record in terms of the
                        Information Technology Act, 2000 (as amended /
                        re-enacted) ("IT Act") and rules thereunder, and is
                        published in accordance with the provisions of Rule 3
                        (1) (a) of the of the Information Technology
                        (Intermediary Guidelines and Digital Media Ethics Code)
                        Rules, 2021, which mandates for publishing of rules and
                        regulations, privacy policy and terms of use for access
                        or usage of Portal. This electronic record is generated
                        by a computer system and does not require any physical
                        or digital signatures.
                      </span>
                    </p>
                  </div>
                </div>

                <div className="section">
                  <h6>2. Changes to the Privacy Policy</h6>
                  <div className="text-content">
                    <p>
                      <span>2.1</span>
                      <span>
                        We are obligated to protect your information in
                        accordance with applicable laws, and regulations.
                      </span>
                    </p>
                    <p>
                      <span>2.2</span>
                      <span>
                        This Privacy Policy is subject to modification based on
                        changes in the business, legal and regulatory
                        requirements and will be updated online. We will notify
                        you whenever any change to the Privacy Policy are made.
                        You are encouraged to periodically visit this page to
                        review the Privacy Policy and any changes to it.
                      </span>
                    </p>
                  </div>
                </div>

                <div className="section">
                  <h6>3. Third Party Services</h6>
                  <div className="text-content">
                    <p>
                      <span>3.1</span>
                      <span>
                        Please note that your mobile service provider, mobile
                        operating system provider, third party applications
                        including the applications pre-loaded on your smart
                        phones powered by Android platform or customized Android
                        ROM ("Device"), social media platforms and websites that
                        you access, third party operators may also collect, use
                        and share information about you and your usage. We
                        cannot control how these third parties collect, use,
                        share or secure this information. For information about
                        third-party privacy practices, please consult their
                        respective privacy policies.
                      </span>
                    </p>
                  </div>
                </div>

                <div className="section">
                  <h6>4. Personal Information we collect</h6>
                  <div className="text-content">
                    <p>
                      <span>4.1</span>
                      <span>
                        Personal information is defined as information that can
                        be used to identify you and may include details such as
                        your name, age, gender, contact information, products
                        and services you are interested in or require more
                        information about. Insofar as sensitive personal
                        information is concerned, it will carry the meaning as
                        may be defined by applicable laws from time to time.
                      </span>
                    </p>

                    <div>
                      <p className="fw-bold">4.2.1 Collection:</p>
                      <p><span>4.2.1.1</span><span className="m-1">You agree that the Portal may collect such personal information, whenever relevant, to help providing you with information and to complete any transaction or provide any product you have requested or authorized. You also consent to the collection of certain personal information in the course of your applying for the products and/or services.</span></p>
                    </div>

                    <div>
                      <p className="fw-bold">4.2.2 Usage:</p>
                      <p><span>4.2.2.1</span><span className="m-1">The Portal seeks this information either to (i) validate and process your request for the services of the Portal or information; (ii) to improve the quality of the Portal; (iii) to assist you to determine which services best meet your needs; or (iv) to facilitate our internal business operations, including the fulfilment of any legal and regulatory requirements; or (v) to provide you with recommendation about services you may be interested in, based on your use of the Portal; or (vi) to provide you with marketing communications and advertising that the Portal believe may be of interest of you ;or (vii) to facilitate your purchases.</span></p>
                    </div>

                    <div>
                      <p className="fw-bold">4.2.3 Sharing:</p>
                      <p><span>4.2.3.1</span><span className="m-1">We may disclose personal information to our affiliates when necessary to perform services on our behalf or on your behalf, to provide display advertising and promotional services, providing search results and links (including paid listings and links), processing credit card payments, providing customer service etc</span></p>
                      <p><span>4.2.3.2</span><span className="m-1">We may also share personal information with external organizations or individuals if we believe that access, use, preservation or disclosure of the information is reasonably necessary to: (a) meet any applicable law, regulation, legal process or enforceable governmental request; (b)detect, prevent or otherwise address fraud, security or technical issues; (c)protect against harm to the rights, property or safety of our customers or the public, as required or permitted by law</span></p>
                    </div>

                    <div>
                      <p className="fw-bold">4.2.4 Retention:</p>
                      <p><span>4.2.4.1</span><span className="m-1">The information so collected shall be retained only for a limited duration necessary to fulfil the purposes outlined herein unless a longer retention period is required or permitted by law and only for the purposes defined above. Once the purpose is achieved, all personal information is deleted in a safe and secure mode.</span></p>
                    </div>
                  </div>
                </div>

                <div className="section">
                  <h6>5. Non-Personal Information:</h6>
                  <div className="text-content">
                    <p>
                      <span>5.1</span>
                      <span>
                        Non-personal information is defined as any data that
                        does not personally identify you and may include unique
                        system or hardware identifiers, system or Portal
                        software, and peripherals.
                      </span>
                    </p>
                    <p>
                      <span>5.2</span>
                      <span>
                        Any non-personal information, when clubbed with personal
                        information shall be treated as personal information.
                      </span>
                    </p>

                    <div>
                      <p className="fw-bold">5.3.1 Collection:</p>
                      <p><span>5.3.1.1</span><span className="m-1">You agree that the Portal may collect diagnostic, technical, usage related information, for the usage purposes described below.</span></p>
                    </div>

                    <div>
                      <p className="fw-bold">5.3.2 Usage:</p>
                      <p><span>5.3.2.1</span><span className="m-1">The above mentioned information is gathered periodically to provide and improve the Portal and services therein, facilitate the provision of software updates, product support and other services to you (if any) and to verify compliance with the terms of this Policy.</span></p>
                    </div>

                    <div>
                      <p className="fw-bold">5.3.3 Sharing:</p>
                      <p><span>5.3.3.1</span><span className="m-1">To enable the Portal partners and third party developers to improve their software, hardware and services designed for use with the Portal, we may also provide any such partner or third party developer with a subset of diagnostic information that is relevant to that partner's or developer's software, hardware and/or services, as long as the diagnostic information is in a form that does not personally identify you.</span></p>
                    </div>

                    <div>
                      <p className="fw-bold">5.3.4 Retention:</p>
                      <p><span>5.3.4.1</span><span className="m-1">The information so collected shall be retained only for a limited duration necessary to fulfil the purposes outlined herein unless a longer retention period is required or permitted by law and only for the purposes defined above. Once the purpose is achieved, all information is deleted in a safe and secure mode.</span></p>
                    </div>
                  </div>
                </div>

                <div className="section">
                  <h6>6. Location Services</h6>
                  <div className="text-content">
                    <p>
                      <span>6.1</span>
                      <span>
                        The Portal, its licensees and agents, may access,
                        collect and analyse your usage of the Portal and other
                        information related to your location on a regular basis
                        through Bluetooth and Wi-Fi signals and other
                        technologies and data for the performance of the
                        services provided by the Portal and to help improve the
                        design, functionality, performance, and content of the
                        Portal. In order to collect geo-location information,
                        the location settings must be enabled on your device.
                        Therefore, in some cases, the Portal may request that
                        you enable the location settings.
                      </span>
                    </p>
                    <p>
                      <span>6.2</span>
                      <span>
                        Except in cases where any specific services requested by
                        you require or involve personal identification, the
                        Portal collects location data anonymously and in a form
                        that does not personally identify you. By using the
                        Portal, you agree and consent to transmission,
                        collection, maintenance, processing and use of your
                        location data and queries to provide and improve such
                        services of the Portal.
                      </span>
                    </p>
                  </div>
                </div>

                <div className="section">
                  <h6>7. Cookies</h6>
                  <div className="text-content">
                    <p>
                      <span>7.1</span>
                      <span>
                        Information collected by cookies and other technologies
                        are treated as non-personal information. However, to the
                        extent that IP addresses or similar identifiers are
                        considered personal information by local law, we treat
                        any information linked to such identifiers as personal
                        information. Similarly, to the extent that non-personal
                        information is combined with personal information, we
                        will treat the combined information as personal
                        information.
                      </span>
                    </p>
                  </div>
                </div>

                <div className="section">
                  <h6>8. Other Information the Portal collects</h6>
                  <div className="text-content">
                    <p>
                      <span>8.1</span>
                      <span>
                        The Portal also may collect other information about you
                        in ways that the Portal describe to you or otherwise
                        with your consent. You can choose not to provide us with
                        certain types of information, but doing so may affect
                        your ability to avail and/or use some services.
                      </span>
                    </p>
                  </div>
                </div>

                <div className="section">
                  <h6>9. Third Party applications, Websites & Services</h6>
                  <div className="text-content">
                    <p>
                      <span>9.1</span>
                      <span>
                        The Portal may include links to other
                        websites/applications or may display advertisements from
                        third parties and other content that links to third
                        party websites. Such websites/applications are governed
                        by their respective privacy policies, which are out of
                        the Portal's control. Use of any information you provide
                        while using a third party website or applications
                        through the Portal, is governed by the privacy policy of
                        the operator of the website / applications / operator
                        you are using/ visiting. That policy may differ from
                        that of the Portal. If you can't find the privacy policy
                        of any of such websites /application via a link from the
                        website's homepage, you should contact the relevant
                        website /application operator directly for more
                        information.
                      </span>
                    </p>
                  </div>
                </div>

                <div className="section">
                  <h6>10. Access, Correction and Deletion</h6>
                  <div className="text-content">
                    <p>
                      <span>10.1</span>
                      <span>
                        The Portal strives hard to keep its records updated and
                        accurate with your latest information. You shall be
                        responsible to ensure that the information or data you
                        provide from time to time is and shall be correct,
                        current and updated and you have all the rights,
                        permissions and consents to provide such information or
                        data.
                      </span>
                    </p>
                    <p>
                      <span>10.2</span>
                      <span>
                        You may note that deletion of certain information or
                        withdrawal of consent may lead to cancellation of your
                        access to the Portal or your access to certain features
                        and services of the Portal. Additionally, we may not be
                        able to process your request of correction, updating or
                        deletion, in case the same is not supported by valid
                        documents or data retention is required by the
                        applicable law or law enforcement requests or under any
                        judicial proceedings or it is extremely difficult to
                        implement (such as requests related to backup copies or
                        if a new system is required to process the request or
                        change of technical design) or risks the privacy of
                        other users.
                      </span>
                    </p>
                  </div>
                </div>

                <div className="section">
                  <h6>11. Queries and Complaint</h6>
                  <div className="text-content">
                    <p>
                      <span>11.1</span>
                      <span>
                        We are committed to protect your personal information
                        collected and processed by us and look forward to your
                        continued support for the same. In case of any feedback
                        or concern regarding protection of your personal
                        information, or any privacy-related feedback or concerns
                        you may contact: Ms Radha Nair at{' '}
                        <a href="mailto:grievance.officer@jio.com">
                          grievance.officer@jio.com
                        </a>
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
